"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LinkButton = _interopRequireDefault(require("./LinkButton.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["children", "href", "variant", "medium", "ariaLabel", "icon"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var LinkButton = function LinkButton(_ref) {
  var children = _ref.children,
    href = _ref.href,
    variant = _ref.variant,
    medium = _ref.medium,
    ariaLabel = _ref.ariaLabel,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], _extends({
    "aria-label": ariaLabel,
    href: href,
    variant: variant,
    medium: medium
  }, otherProps), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "button-icon",
    size: otherProps.iconSize || 24,
    icon: icon
  }), children);
};
LinkButton.defaultProps = {
  href: undefined,
  medium: false,
  variant: 'link',
  ariaLabel: '',
  icon: undefined,
  iconSize: undefined
};
LinkButton.propTypes = {
  ariaLabel: _propTypes["default"].string,
  /** Text or html to be displayed inside the button */
  children: _propTypes["default"].node.isRequired,
  /** A link to navigate to */
  href: _propTypes["default"].string,
  /** Flag for medium link button */
  medium: _propTypes["default"].bool,
  /** Link button variant */
  variant: _propTypes["default"].oneOf(['primary', 'naked', 'link', 'text']),
  icon: _propTypes["default"].string,
  iconSize: _propTypes["default"].number
};
var _default = exports["default"] = LinkButton;